import { render } from "./CabezoteA.vue?vue&type=template&id=09f30b2a"
import script from "./CabezoteA.vue?vue&type=script&lang=js"
export * from "./CabezoteA.vue?vue&type=script&lang=js"

import "./CabezoteA.vue?vue&type=style&index=0&id=09f30b2a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__